import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { getIsAuthenticated } from '../../selectors/user';
import { setNewAnswerFormOpen } from '../../actions/newAnswer/openFormActions';
import { requestAuthentication } from '../../actions/authentication';
import { ButtonLink } from '../../components/ButtonLink';
import { TAnswerTarget } from '../../types/answers';
import { TThunkDispatch } from '../../types/redux';

interface INewAnswerButtonContainerProps {
  type: TAnswerTarget;
  targetId: string;
}

export const NewAnswerButtonContainer = ({ targetId, type }: INewAnswerButtonContainerProps) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const setNewAnswerFormOpenByReviewId = React.useCallback(() => {
    return setNewAnswerFormOpen({ id: targetId, type });
  }, [targetId, type]);

  const onOpen = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setNewAnswerFormOpenByReviewId());
    } else {
      dispatch(requestAuthentication({ onSuccess: setNewAnswerFormOpenByReviewId }));
    }
  }, [isAuthenticated, setNewAnswerFormOpenByReviewId]);

  return <ButtonLink onClick={onOpen}>Ответить</ButtonLink>;
};
